import React, {useState} from "react";

import {View, Text, ScrollView, StyleSheet, TouchableOpacity, Image, Dimensions, TextInput} from "react-native";


import {RFValue} from "react-native-responsive-fontsize";
import {EvilIcons, FontAwesome6, Ionicons} from "@expo/vector-icons";
import Config from "../../Config";
import AntDesign from "@expo/vector-icons/AntDesign";
import toast from "../Components/Toast";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import Toast from "../Components/Toast";





const SendTicket =({navigation})=>{

    let [subject,setSubject]=React.useState("");
    let [text,setText]=React.useState("");
    let [disable,setDisable] = React.useState(false);

    const SendData = async ()=>{
        setDisable(true);
          if(subject.length == 0){
              toast('عنوان را وارد کنید');
              return false;
          }
        if(text.length == 0){
            toast('متن پیام را وارد کنید');
            return false;
        }

        try {
            let token = await AsyncStorage.getItem('token');


            let formData = new FormData();
            formData.append('subject', subject);
            formData.append('text', text);

            let res = await axios.post(
                `${Config.api}/ticket/newticket`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Authorization": 'Bearer '+token
                    }
                }
            );

            setDisable(false);


            if(res.data.code != 1){
                // alert(JSON.stringify(res.data));
                // console.log(res.data.data);
                Toast(res.data.error);
            }
            navigation.navigate("Tickets");
            toast('پیام شما با موفقیت ارسال شد.');
        } catch (err) {
            console.log(err);
            alert('خطا')
        }
    };





    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <TouchableOpacity style={{flex : 1}} >
                    <Text style={styles.title}>
                        ارسال پیام جدید
                    </Text>
                </TouchableOpacity>
                <TouchableOpacity onPress={()=>{navigation.goBack()}}>
                    {/*<Ionicons style={styles.selficon} name="arrow-back" size={24} color="white" />*/}
                    <EvilIcons name="close" size={24} color="white" />
                </TouchableOpacity>
            </View>
            <View style={styles.content}>
                <Text style={styles.label}>
                    عنوان
                </Text>
                <View style={styles.input}>
                    <TextInput
                        value={subject}
                        placeholderTextColor={'#A6A6A6'}
                        placeholder={'عنوان پیام خود را وارد کنید'}
                        onChangeText={setSubject}
                        style={{direction : 'rtl',width : '100%',fontFamily : 'yk',textAlign : 'right'  , letterSpacing : 1 , backgroundColor : '#FAFBFF' , color:Config.maincolor }}
                        keyboardType={'twitter'}
                        maxLength={11}
                    />
                </View>
                <Text style={styles.label}>
                    پیام شما
                </Text>
                <View style={styles.input2}>
                    <TextInput

                        placeholderTextColor={'#A6A6A6'}
                        placeholder={'نوشتن پیام'}
                        multiline={true}
                        value={text}
                        onChangeText={setText}
                        style={{direction : 'rtl',width : '100%',fontFamily : 'yk',textAlign : 'right'  , letterSpacing : 1 , backgroundColor : '#FAFBFF' ,color:Config.maincolor }}
                        keyboardType={'default'}
                        // maxLength={11}
                    />
                </View>
                <View style={{flexDirection : 'row', justifyContent:'flex-end', alignItems: 'flex-end'}}>
                    <TouchableOpacity disabled={disable} onPress={SendData} style={styles.button}>
                        <Text style={styles.buttonText}> ارسال پیام </Text>
                    </TouchableOpacity>
                </View>






            </View>


        </View>
    );
}

const styles = StyleSheet.create({

    buttonText : {
        fontFamily : 'ykb',
        fontSize : RFValue(16),
        color : Config.maincolor,
    },
    button : {
        backgroundColor: Config.secondcolor,
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop : RFValue(20),
        borderRadius : RFValue(55),
        height : RFValue(60),
        width : RFValue(150),

    },

    input :{
        borderStyle:'solid',
        borderColor:'#E7E9F2',
        borderWidth:1,
        borderRadius : RFValue(10),
        height : RFValue(50),
        paddingVertical : RFValue(1),
        paddingHorizontal : RFValue(5),
        backgroundColor: '#FAFBFF',

        marginTop : RFValue(0),
        justifyContent: 'center',
        alignItems: 'center',

    },
    input2 :{
        borderStyle:'solid',
        borderColor:'#E7E9F2',
        borderWidth:1,
        borderRadius : RFValue(10),
        height : RFValue(50),
        paddingVertical : RFValue(1),
        paddingHorizontal : RFValue(5),
        backgroundColor: '#FAFBFF',

        marginTop : RFValue(0),
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        minHeight : RFValue(150)

    },

    label: {
        fontSize: RFValue(16),
        marginTop : RFValue(15),
        marginBottom : RFValue(10),
        fontFamily: 'yk',
        color: Config.maincolor,
    },





    content : {
        flex: 1,
        paddingHorizontal: RFValue(20),

        paddingVertical: RFValue(20),
        backgroundColor :'#FFF',
    },

    container : {
        flex: 1,
        backgroundColor: '#FFF',
    },
    header: {
        flexDirection : 'row',
        justifyContent : 'flex-start',
        alignItems : 'center',

        backgroundColor: '#000422',
        paddingHorizontal: RFValue(20),

        shadowColor:"#000000",
        shadowOffset: {
            width: 0,
            height: 50,
        },
        shadowOpacity: 1,
        shadowRadius: 0,
        elevation: 1
    },


    title : {
        fontSize: RFValue(17),
        fontFamily : 'ykb',
        color: '#FFF',
        paddingVertical: RFValue(14),

    },

})


export default SendTicket